import { render, staticRenderFns } from "./PaymentAmountForm.vue?vue&type=template&id=347e3b0c&"
import script from "./PaymentAmountForm.vue?vue&type=script&lang=js&"
export * from "./PaymentAmountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports